import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { FiChevronDown } from 'react-icons/fi';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

// Exports
type Props = { isDisabled?: boolean; implementationId?: string };
export const EditAssignmentDropdown = ({
  isDisabled,
  implementationId,
}: Props) => {
  const flags = useFeatureFlags();
  const navigate = useNavigate();

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<FiChevronDown />}
        variant="outline"
        colorScheme="aurora"
        border="2px solid"
        isDisabled={isDisabled}
      >
        Edit Assignments
      </MenuButton>
      {implementationId && (
        <MenuList zIndex={10}>
          {flags.assignByStrategy && (
            <MenuItem
              onClick={() =>
                navigate(`/assignments/${implementationId}/strategy`)
              }
            >
              By Strategy
            </MenuItem>
          )}
          <MenuItem
            onClick={() =>
              navigate(`/assignments/${implementationId}/edit-by-csv`)
            }
          >
            By .csv
          </MenuItem>
          {flags.assignByIndividualReceivable && (
            <MenuItem onClick={() => navigate('/assignments/edit')}>
              By Individual Receivable
            </MenuItem>
          )}
        </MenuList>
      )}
    </Menu>
  );
};
